/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
/* eslint-enable no-restricted-imports */
import useSWR from "swr";

export const useGetStatusChangedEventIds = () => {
  return useSWR<string[]>("news/topInfo", async () => {
    const snapshot = await firebase
      .firestore()
      .collection("news")
      .doc("topInfo")
      .get();
    const data = snapshot.data();
    return data?.statusChangeEventIds;
  });
};
